module.exports = __webpack_public_path__ + "img/play-button.0d559d97ea8b115596c4367daaa9b485.svg";